define(["mw-log/Log", "mw-messageservice/MessageService", "./Sender", "mw-utils/Utils"], function (Log, MessageService, Sender, Utils) {
  "use strict";

  var _exports = {};
  /**
   *  Copyright 2018-2023 The MathWorks, Inc.
   */

  const USAGE_SETUP_CHANNEL = '/UsageSetup';
  const USAGE_DATA_CHANNEL = '/UsageData';
  const USAGE_RESPONSE_CHANNEL = '/UsageResponse';

  /**
   * Defines class that sends DDUX data via backend NATLAB
   * @private
   */
  class MatlabSender extends Sender {
    /**
     * Constructor - Initiates communication with the backend MATLAB
     *
     * @param loggerProperties {object} supplies default values for certain event attributes.
     * @param loggerProperties.product {string} identifies the product for all UI event and
     *        telemetry logs unless overriden
     * @param loggerProperties.scope {string} identifies the scope for all UI event logs
     *        unless overridden.
     * @param loggerProperties.applicationName {string} the name of the application logging data. Optional,
     * if not specified the application will that of the back end MATLAB.
     * @param loggerProperties.applicationVersion {string} the version of the application logging data;
     * Optional, if not specified the application version will be that of the backed MATLAB.
     */
    constructor(loggerProperties) {
      super();
      MessageService.start();
      this._channel = USAGE_DATA_CHANNEL + '/' + Utils.generateUuid();
      this._responseChannel = USAGE_RESPONSE_CHANNEL + '/' + Utils.generateUuid();
      const message = {
        type: 'start',
        product: loggerProperties.product,
        scope: loggerProperties.scope,
        channel: this._channel,
        responseChannel: this._responseChannel,
        url: typeof window !== 'undefined' ? window.location.href : 'unknown URL',
        title: document.title
      };
      if (loggerProperties.applicationName) {
        message.applicationName = loggerProperties.applicationName;
      }
      if (loggerProperties.applicationVersion) {
        message.applicationVersion = loggerProperties.applicationVersion;
      }
      MessageService.publish(USAGE_SETUP_CHANNEL, message);
    }

    /**
     * Terminates communication with the backend MATLAB
     */
    stop() {
      MessageService.publish(USAGE_SETUP_CHANNEL, {
        type: 'stop',
        channel: this._channel,
        responseChannel: this._responseChannel
      });
    }

    /**
     * Sends an event to the MATLAB backend
     *
     * @param eventType "telemetry", "uiEvent" or "composition"
     * @param event the attributes that define the event
     */
    sendEvent(eventType, event) {
      // To Consider: Either use wrapper to convey 'messageType' or change to a name unlikely
      // to conflict, such as _messageType.
      if (!(eventType === 'telemetry' || eventType === 'uiEvent' || eventType === 'composition')) {
        Log.info('Send via MATLAB not supported for ' + eventType + ' events');
        return;
      }
      event.messageType = eventType;
      MessageService.publish(this._channel, event);
    }
  }
  _exports.default = MatlabSender;
  return _exports.default;
});
//# sourceMappingURL=MatlabSender.js.map
